function getUserAgent(): string | undefined {
  if (import.meta.server) {
    return useRequestHeaders(['user-agent'])['user-agent']
  }

  if (import.meta.client) {
    return navigator.userAgent
  }

  return undefined
}

function isRootPath(path: string) {
  return path === '/' || path === ''
}

export default defineNuxtRouteMiddleware((to) => {
  syncCountryCookie()

  if (to.path === '/hu' || to.path === '/hu/') {
    return navigateTo({ path: '/', query: to.query, hash: to.hash }, { replace: true })
  }

  const isRoot = isRootPath(to.path)
  const param = to.params.locale
  const segment = Array.isArray(param) ? param[0] : param
  const { applyLocale } = useI18n()

  if (isSearchCrawler(getUserAgent())) {
    if (isRoot) {
      applyLocale(PRIMARY_LOCALE)
      return
    }

    if (isLocalizedSegment(segment)) {
      applyLocale(segment)
    }

    return
  }

  const savedLocale = hasAcceptedConsent() && hasFunctionalConsent() ? getSavedLocale() : null
  if (savedLocale) {
    const targetPath = localePath(savedLocale)

    if (to.path !== targetPath) {
      return navigateTo({ path: targetPath, query: to.query, hash: to.hash }, { replace: true })
    }

    applyLocale(savedLocale)
    return
  }

  if (isRoot) {
    applyLocale(PRIMARY_LOCALE)
    return
  }

  if (!segment || !isLocalizedSegment(segment)) {
    throw createError({ statusCode: 404, statusMessage: 'Page not found' })
  }

  applyLocale(segment)
})